import { Component, State, h } from '@stencil/core';
import Cookies from 'js-cookie';

import cart from '../../assets/header/cart.svg';

@Component({
  tag: 'ci-cart',
  styleUrl: 'ci-cart.scss',
})
export class CiCart {
  @State() cartCookie = Cookies.get('oa_cart');
  @State() showCart = () => this.cartCookie !== undefined;

  cartCount = (cookie: string) => JSON.parse(cookie).order_item_count;

  componentWillLoad() {
    window.addEventListener('cartCookieUpdated', this.refreshCartCookie);
  }

  refreshCartCookie = () => {
    this.cartCookie = Cookies.get('oa_cart');
  };

  disconnectedCallback() {
    window.removeEventListener('cartCookieUpdated', this.refreshCartCookie);
  }

  render() {
    if (this.showCart()) {
      return (
        <div class="ciHeader-cart">
          <div class="ciHeader-cart-count">{this.cartCount(this.cartCookie)}</div>
          <icon-button href={`${process.env.CI_HOSTNAME}/checkout/summary`} icon={cart} alt="cart icon"></icon-button>
        </div>
      );
    }
    return;
  }
}
